import { render, staticRenderFns } from "./promoters_report.vue?vue&type=template&id=59221fa9"
import script from "./promoters_report.vue?vue&type=script&lang=js"
export * from "./promoters_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports